import { Component, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { NgClass } from '@angular/common';
import { BsModalService } from 'ngx-bootstrap/modal';
import { cvNewFile } from 'src/assets/js/draw';
import { ToastrService } from 'ngx-toastr';
import { SessionManagerService } from '../../../../../shared/services/session/session-manager.service';
import { CommonService, LoaderService, RequestService } from 'src/app/shared/services';
import { Messages } from '../../../../../shared/constant/messages';
import { FileManagerService } from '../../../services/file-manager.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CanvasService } from '../../services/canvas.service';
import { SHORT_CUTS_WITH_EXTRA_ACTIONS } from 'src/app/shared/constant/shortCutsKeys';
import { Constants } from 'src/app/shared/constant/constants';
import { Router } from '@angular/router';
import { NgZone } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { FocusOnInitDirective } from '@app/shared/directive/modal-focus.directive';
import { ProgressbarModule } from 'ngx-bootstrap/progressbar';
import { ReactiveFormsModule } from '@angular/forms';
import { NgIf } from '@angular/common';
import { AssignmentService } from '@app/features/student/services/assignment.service';
import { CV_COLOR_1 } from '@app/shared/constant/canvasSymTypes';
import { DynamicTabIndexDirective } from '@app/shared/directive/dynamic-tab-index.directive';
import { CANVAS_DASHBOARD, CANVAS_DASHBOARD_DRIVE_FILES, FILE_MANAGER } from '@app/shared/constant/routes';
import { ToolbarService } from '../../services/toolbar.service';
import {
  EmptyFileError,
  FileTooLargeError,
  IMPORT_MIME,
  base64ToFile,
  buildUploadFile,
  bytesToDataUrl,
  bytesToText,
  isSupportedImportMime,
  readFileBytes,
  sniffMimeType,
} from '@app/shared/helper/file-import';

/** How often the indeterminate progress bar advances. */
const PROGRESS_TICK_MS = 3000;
/**
 * Hard ceiling on an import. The bar tops out at 98% and only a callback clears it, so without a
 * deadline any path that never calls back parks a student in front of a frozen bar indefinitely.
 */
const IMPORT_DEADLINE_MS = 120_000;

declare let pdfjsLib: any;
declare let gapi: any;
declare let google: any;

@Component({
  selector: 'app-choose-file-popup',
  templateUrl: './choose-file-popup.component.html',
  styleUrls: ['./choose-file-popup.component.scss'],
  standalone: true,
  imports: [NgIf, ReactiveFormsModule, ProgressbarModule, TranslateModule, FocusOnInitDirective, DynamicTabIndexDirective, NgClass],
})
export class ChooseFilePopupComponent implements OnInit, OnDestroy {
  destroy$: Subject<boolean> = new Subject<boolean>();
  isFileUpload = false;
  selectedLevel: number;
  fileTypeError = '';
  isPdf = false;
  binaryUrl!: any;
  kiwiFileData!: any;
  file!: any;
  startUploading = 0;
  interval!: any;
  keyDownListener!: any;
  /**
   * The picked file's bytes, held from the moment of selection.
   *
   * This — never the `File` from the input — is what gets uploaded. See `file-import.ts` for why
   * the original handle cannot be trusted to still have contents by the time OK is pressed.
   */
  private importBytes: ArrayBuffer | null = null;
  private importDeadlineId: any;
  // isSubmitAssignmentButtonEnable!: any;
  isFileCreated = false;
  lastOpenedFileDetails: any = null;

  developerKey = 'AIzaSyBdyoG4zFtUAvfMzoDpNC_j8qMYsvU-dM4';
  pickerApiLoaded = false;
  oauthToken?: any;

  constructor(
    private readonly modalService: BsModalService,
    private readonly flashService: ToastrService,
    private readonly sessionManagerService: SessionManagerService,
    private readonly fileManagerService: FileManagerService,
    private readonly canvasService: CanvasService,
    private readonly renderer2: Renderer2,
    private commonService: CommonService,
    private router: Router,
    private readonly ngZone: NgZone,
    private assignmentService: AssignmentService,
    private requestService: RequestService,
    private loader: LoaderService,
    private readonly toolbarService: ToolbarService,
    private readonly translateService: TranslateService,
  ) {
    this.selectedLevel = +this.sessionManagerService.getUserMathLevelId().matheLevelNo;
    this.handleAuthResult = this.handleAuthResult.bind(this);
  }

  toCancel() {
    this.modalService.hide();
  }

  goToImportPage() {
    this.resetImportState();
    this.isFileUpload = false;
  }

  finishUpload() {
    this.clearImportTimers();
    this.startUploading = 100;
  }

  private clearImportTimers() {
    clearInterval(this.interval);
    this.interval = undefined;
    clearTimeout(this.importDeadlineId);
    this.importDeadlineId = undefined;
  }

  /**
   * Ends a failed import: timers down, bar hidden (the template keys off a falsy value), message
   * shown. Leaving the bar at 98% with nothing running is the bug this whole change is about.
   */
  private failImport(err?: any) {
    this.clearImportTimers();
    this.startUploading = 0;
    const key = err instanceof EmptyFileError ? 'ERROR.fileImportUnreadable' : 'ERROR.fileImportFailed';
    this.flashService.error(this.translateService.instant(key));
  }

  ngOnInit(): void {
    this.canvasService.setIsAnyInputPopupOpen(true);
    this.checkLastFileDetails();
    this.openFile();
    this.keyDownListener = this.renderer2.listen('window', 'keydown', event => {
      const key = event.key;
      if (key.toLowerCase() === 'tab' || key.toLowerCase() === 'enter') {
        return;
      }
      event.preventDefault();
      event.stopPropagation();
      if (event.ctrlKey && event.code === SHORT_CUTS_WITH_EXTRA_ACTIONS.KeyI) {
        this.isFileUpload = true;
      }
    });
  }
  createNewBlankFile(file?: any, bitmaps?: string[], importedFileName?: string) {
    if (file) {
      this.commonService.setCanvasBackgroundColor(CV_COLOR_1);
    } else {
      const prefs = this.sessionManagerService.getUserPreferences();
      this.commonService.setCanvasBackgroundColor(prefs?.backgroundColor);
    }

    // this.isSubmitAssignmentButtonEnable();
    cvNewFile(
      this.selectedLevel,
      this.isPdf ? '' : this.binaryUrl,
      bitmaps,
      this.kiwiFileData ? JSON.stringify(JSON.parse(this.kiwiFileData).mathKeys) : null,
      false,
      false,
      this.sessionManagerService.getAnalyticsType(),
    );
    // Extract filename from uploaded file if available
    const fileName = importedFileName || file?.filename || this.file?.name || null;

    this.fileManagerService
      .createNewFile(
        file,
        this.isPdf ? '' : this.binaryUrl,
        bitmaps,
        this.kiwiFileData ? JSON.parse(this.kiwiFileData).mathKeys : {},
        this.kiwiFileData ? JSON.parse(this.kiwiFileData).mathLevelId : null,
        fileName,
      )
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        res => {
          this.finishUpload();

          if (res?.message) {
            this.flashService.success(res.message);
          }

          if (this.selectedLevel === 3) {
            this.commonService.sendUpdate(false);
          }

          this.toCancel();
        },
        err => {
          this.finishUpload();
          this.flashService.error(err);
          this.toCancel();
        },
      );
  }

  /**
   * Reads the picked file into memory and decides what it is, from its contents.
   *
   * Deliberately does not consult `file.type` or the filename extension: iPadOS hands over
   * emailed/downloaded files with neither, which is why perfectly good JPGs were being rejected as
   * unsupported until a `.jpg` was typed back into the name.
   */
  async handleFileInput(eventTarget: EventTarget | null) {
    const picked = (eventTarget as HTMLInputElement).files?.[0];
    if (!picked) {
      return;
    }

    this.resetImportState();

    let bytes: ArrayBuffer;
    try {
      bytes = await readFileBytes(picked);
    } catch (err) {
      // An empty read is the iPadOS stale-handle case and has its own advice; too large has its
      // own limit to quote; anything else is a genuinely unreadable file.
      if (err instanceof FileTooLargeError) {
        this.fileTypeError = this.translateService.instant('ERROR.fileImportTooLarge');
      } else if (err instanceof EmptyFileError) {
        this.fileTypeError = this.translateService.instant('ERROR.fileImportUnreadable');
      } else {
        this.fileTypeError = Messages.validationMessage.InvalidFile;
      }
      return;
    }

    const mime = sniffMimeType(bytes) as string;
    if (!isSupportedImportMime(mime)) {
      this.fileTypeError = Messages.validationMessage.fileTypeError;
      return;
    }

    const isPdf = mime === IMPORT_MIME.PDF;
    const isKiwi = mime === IMPORT_MIME.KIWI;

    // Decode before committing anything, so a malformed file leaves the popup as it was rather
    // than half-loaded with an upload that would fail later.
    let kiwiText: string | null = null;
    let level = this.selectedLevel;
    let dataUrl: string | null = null;
    try {
      if (isKiwi) {
        kiwiText = bytesToText(bytes);
        level = +JSON.parse(kiwiText)?.mathKeys?.mathLevel;
      } else if (!isPdf) {
        // The canvas wants an image source. A PDF reaches it as bitmaps later, so it needs nothing
        // here and a second copy of the buffer would only double the memory.
        dataUrl = bytesToDataUrl(bytes, mime);
      }
    } catch (err) {
      console.error('[ChooseFilePopup] Could not decode the selected file:', err);
      this.fileTypeError = Messages.validationMessage.InvalidFile;
      return;
    }

    this.fileTypeError = '';
    this.importBytes = bytes;
    this.isPdf = isPdf;
    this.kiwiFileData = kiwiText;
    this.selectedLevel = level;
    this.binaryUrl = dataUrl;
    // Rebuilt from the bytes, and renamed to match them, so the stored S3 key carries the right
    // extension even when the picked file had none.
    this.file = buildUploadFile(bytes, picked.name, mime);
  }

  private resetImportState() {
    this.importBytes = null;
    this.binaryUrl = null;
    this.kiwiFileData = null;
    this.file = null;
    this.isPdf = false;
  }

  private encodeUrlPath(url: string): string {
    // Manually parse URL to handle unencoded # in path (which URL constructor treats as fragment)
    const protocolMatch = url.match(/^(https?:\/\/[^\/]+)/);
    if (!protocolMatch) {
      return url;
    }

    const base = protocolMatch[1];
    const rest = url.substring(base.length);

    const queryIndex = rest.indexOf('?');

    const pathPortion = queryIndex !== -1 ? rest.substring(0, queryIndex) : rest;
    const queryPortion = queryIndex !== -1 ? rest.substring(queryIndex) : '';

    const encodedPath = pathPortion
      .split('/')
      .map(segment => {
        try {
          const decoded = decodeURIComponent(segment);
          return encodeURIComponent(decoded);
        } catch (e) {
          return encodeURIComponent(segment);
        }
      })
      .join('/');

    return base + encodedPath + queryPortion;
  }

  parsePdf(file: any) {
    const encodedUrl = this.encodeUrlPath(file.location);
    const loadingTask = pdfjsLib.getDocument({ url: encodedUrl, isEvalSupported: false });
    loadingTask.promise
      .then((pdf: any) => {
        if (pdf.numPages > 10) {
          this.clearImportTimers();
          this.startUploading = 0;
          this.fileTypeError = Messages.validationMessage.pdfPageNumebrs;
          return;
        }
        return this.fileManagerService.generateBitmap(pdf).then((res: string[]) => {
          // Pass the filename from the upload response
          const importedFileName = file?.filename || this.file?.name || null;
          this.createNewBlankFile(file, res, importedFileName);
        });
      })
      .catch((err: any) => {
        // A PDF that stored empty, or that pdf.js cannot render, used to reject into nothing and
        // leave the bar at 98%.
        console.error('[ChooseFilePopup] Could not render the imported PDF:', err);
        this.failImport(err);
      });
  }

  toRenderFile() {
    if (!this.importBytes && !this.kiwiFileData) {
      this.fileTypeError = Messages.validationMessage.fileRequiredError;
      return;
    }

    this.startImportProgress();

    if (this.kiwiFileData) {
      const kiwiData = JSON.parse(this.kiwiFileData);
      if (kiwiData.pdfOrImageData === null) {
        // only math keys
        this.createNewBlankFile();
        return;
      }

      // mathkeys + image/pdf
      const file = base64ToFile(kiwiData.pdfOrImageData, 'kiwifile');
      if (!file) {
        this.clearImportTimers();
        this.startUploading = 0;
        this.fileTypeError = Messages.validationMessage.fileRequiredError;
        return;
      }

      this.fileManagerService.uploadAFile(file).subscribe(
        (res: any) => {
          this.isPdf = res?.data?.mimetype.split('/')[1] === 'pdf';
          this.binaryUrl = res?.data?.mimetype.split('/')[1] === 'pdf' ? null : kiwiData.pdfOrImageData;
          // Extract filename from upload response - prioritize res.data.filename, then fallback to original file name
          const importedFileName = res?.data?.filename || file?.name || null;
          console.log('Upload response (choose-file kiwi):', res);
          console.log('Extracted filename (choose-file kiwi):', importedFileName);
          res?.data?.mimetype.split('/')[1] === 'pdf'
            ? this.parsePdf({ ...res.data, filename: importedFileName })
            : this.createNewBlankFile(res.data, undefined, importedFileName);
        },
        (err: any) => {
          this.finishUpload();
          this.flashService.error(err?.message || 'File upload failed. Please try again.');
        },
      );
      return;
    }

    // iOS/WebKit fix: upload the bytes read into memory at selection, not the stale input File.
    const uploadFile = this.buildInMemoryUploadFile() ?? this.file;
    this.fileManagerService.uploadAFile(uploadFile).subscribe(
      (res: any) => {
        const importedFileName = res?.data?.filename || this.file?.name || null;
        console.log('Upload response (choose-file):', res);
        console.log('Extracted filename (choose-file):', importedFileName);
        this.isPdf ? this.parsePdf({ ...res.data, filename: importedFileName }) : this.createNewBlankFile(res.data, undefined, importedFileName);
      },
      (err: any) => {
        // Without this handler a failed/empty upload leaves the progress bar spinning forever.
        this.finishUpload();
        this.flashService.error(err?.message || 'File upload failed. Please try again.');
      },
    );
  }

  private startImportProgress() {
    this.clearImportTimers();
    this.startUploading = 1;
    this.interval = setInterval(() => {
      if (this.startUploading >= 100) return;

      this.startUploading = this.startUploading * 2 > 100 ? 98 : this.startUploading * 2;
    }, PROGRESS_TICK_MS);
    this.importDeadlineId = setTimeout(() => this.failImport(), IMPORT_DEADLINE_MS);
  }

  ngOnDestroy(): void {
    this.keyDownListener();
    this.clearImportTimers();
    this.canvasService.setIsAnyInputPopupOpen(false);
  }

  // Google Picker integration
  loadGoogleDrive() {
    gapi.load('picker', { callback: this.onPickerApiLoad.bind(this) });
  }

  onPickerApiLoad() {
    this.pickerApiLoaded = true;
    this.createPicker();
  }

  createPicker() {
    if (this.pickerApiLoaded && this.oauthToken) {
      const picker = new google.picker.PickerBuilder()
        .addView(google.picker.ViewId.DOCS)
        .setOAuthToken(this.oauthToken)
        .setDeveloperKey(this.developerKey)
        .setCallback(this.pickerCallback.bind(this))
        .build();
      picker.setVisible(true);
    }
    this.handleAuthResult();
  }

  pickerCallback(data: any) {
    // let url = '';
    if (data[google.picker.Response.ACTION] == google.picker.Action.PICKED) {
      // const doc = data[google.picker.Response.DOCUMENTS][0];
      // url = doc[google.picker.Document.URL];
    }
  }

  handleAuthResult() {
    const accessToken = this.sessionManagerService.getAccessToken();
    // let src;
    this.fileManagerService.checkGoogleAccessToke(accessToken).subscribe(
      (res: any) => {
        if (accessToken && res.code != 504) {
          const view = new google.picker.View(google.picker.ViewId.DOCS);
          view.setMimeTypes('image/png,image/jpeg,image/jpg,application/pdf');
          const pickerBuilder = new google.picker.PickerBuilder();
          const picker = pickerBuilder
            .setOAuthToken(accessToken)
            .addView(view)
            .hideTitleBar()
            .addView(google.picker.ViewId.PDFS)
            .addView(google.picker.ViewId.FOLDERS)
            .setCallback((e: any) => {
              if (e[google.picker.Response.ACTION] == google.picker.Action.PICKED) {
                const doc = e[google.picker.Response.DOCUMENTS][0];
                // src = doc[google.picker.Document.URL];
                this.driveFileNavigate(doc);
              }
            })
            .build();
          picker.setVisible(true);
          this.toCancel();
        }
      },
      err => {
        console.log('error', err);
      },
    );
  }

  driveFileNavigate(doc: any) {
    const googleDriveId = doc.id;
    const ifRedirectionURL = `/student/drive?state={"ids":["${googleDriveId}"],"action":"open","userId":"","resourceKeys":{}}`;
    this.ngZone.run(() => {
      this.router.navigateByUrl(ifRedirectionURL).then(() => {
        window.location.reload();
      });
    });
  }

  /**
   * Rebuild the file to upload from the bytes already read into memory at selection
   * (this.binaryUrl), instead of the original <input type=file> File. On iOS/WebKit that
   * original File is a reference to an on-disk (often temporary, e.g. camera) file the OS can
   * release before OK is clicked, so re-reading it at upload yields 0 bytes -> empty file to
   * the backend -> import hangs. Falls back to this.file if the in-memory bytes aren't available.
   */
  private buildInMemoryUploadFile(): File | null {
    if (this.binaryUrl == null) {
      return null;
    }
    const fileName = this.file?.name || 'import';
    if (this.binaryUrl instanceof ArrayBuffer) {
      // PDF path (readAsArrayBuffer)
      return new File([this.binaryUrl], fileName, { type: this.file?.type || 'application/pdf' });
    }
    if (typeof this.binaryUrl === 'string') {
      // image path: data URL from readAsDataURL, e.g. "data:image/jpeg;base64,..."
      const comma = this.binaryUrl.indexOf(',');
      if (comma === -1) {
        return null;
      }
      const mime = this.binaryUrl.substring(0, comma).match(/:(.*?);/)?.[1] || this.file?.type || '';
      const bstr = atob(this.binaryUrl.substring(comma + 1));
      let n = bstr.length;
      const u8 = new Uint8Array(n);
      while (n--) {
        u8[n] = bstr.charCodeAt(n);
      }
      return new File([u8], fileName, { type: mime });
    }
    return null;
  }

  triggerFileInput(): void {
    const fileInput = document.getElementById('file-input-new') as HTMLInputElement;
    if (fileInput) {
      fileInput.click();
    }
  }
  openFileManager() {
    this.router.navigate([FILE_MANAGER.URL]);
  }
  openMostRescentFile() {
    if (this.lastOpenedFileDetails === null) {
      return;
    }
    if (this.isGoogleFile(this.lastOpenedFileDetails) && this.sessionManagerService.getisIntegratedWithGoogle() !== 'true') {
      this.showGoogleIntegrationRemovedError();
      return;
    }
    let queryParams: { [key: string]: string } = {};
    let url: string[] = [];

    if (this.lastOpenedFileDetails != null && this.isGoogleFile(this.lastOpenedFileDetails)) {
      const userId = this.sessionManagerService.getUserId();
      const driveQuery = `{"ids":["${this.lastOpenedFileDetails.googleDriveFileId}"],"action":"open","userId":"${userId}","resourceKeys":{}}`;
      ((url = [`${CANVAS_DASHBOARD_DRIVE_FILES.URL}`]), (queryParams = { state: driveQuery, level: this.lastOpenedFileDetails.levelNo }));
    } else if (this.lastOpenedFileDetails != null && !this.isGoogleFile(this.lastOpenedFileDetails)) {
      const levelNo = this.lastOpenedFileDetails.levelNo ? this.lastOpenedFileDetails.levelNo : 1;
      url = [`${CANVAS_DASHBOARD.URL}/${levelNo}`];
      if (this.lastOpenedFileDetails) {
        queryParams = {
          fileId: this.lastOpenedFileDetails.firebaseFileId,
          bfileId: this.lastOpenedFileDetails.id,
        };
      }
    }
    this.router.navigate(url, { queryParams }).then(() => {
      setTimeout(() => {
        window.location.reload();
      }, 500);
    });
  }

  checkLastFileDetails() {
    const data = history.state;
    if (data?.disabledMostRescentBox) {
      this.lastOpenedFileDetails = null;
      return;
    }

    this.loader.start();
    this.requestService.get(`${Constants.ENDPOINTS.getMostRescentFileDetails}`).subscribe(
      (res: any) => {
        this.lastOpenedFileDetails = res.data.lastOpenedFileInfo;
        if (this.isGoogleFile(this.lastOpenedFileDetails) && this.sessionManagerService.getisIntegratedWithGoogle() !== 'true') {
          this.lastOpenedFileDetails = null;
        }
        this.isFileCreated = res.data.isFileCreated;
        this.loader.stop();
      },
      (err: any) => {
        console.error('Error fetching most rescent file:', err);
        this.lastOpenedFileDetails = null;
        this.isFileCreated = false;
        this.loader.stop();
      },
    );
  }

  private isGoogleFile(fileDetails: any): boolean {
    return !!fileDetails?.googleDriveFileId;
  }

  private showGoogleIntegrationRemovedError() {
    // Guarded here so every caller inherits it: a cleared session (logout, update teardown) leaves
    // the flag empty, which is not the same as the school having removed integration.
    if (!this.sessionManagerService.isGoogleIntegrationRemoved()) return;
    this.translateService.get('googleIntegrationRemovedError').subscribe((translatedMessage: string) => {
      this.flashService.error(translatedMessage);
    });
  }
  async openFile() {
    localStorage.removeItem('isConnectionExists');
    try {
      const resp = await this.requestService
        .get<{
          data: {
            isConnectionExists: boolean;
          };
        }>(Constants.TEACHER_ENDPOINTS.checkConnection)
        .toPromise();

      if (resp?.data?.isConnectionExists) {
        localStorage.setItem('isConnectionExists', String(resp.data.isConnectionExists));
      } else {
        localStorage.removeItem('isConnectionExists');
      }
    } catch (err) {
      this.flashService.error('Something went wrong');
    }
  }

  logout() {
    localStorage.setItem('logout', 'true');
    this.toolbarService.logoutWithOutSave();
  }
}
